import React, { useState, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { ApiContext } from "../../contexts/ApiContext";
import { accountPath } from "../../utils/accountPath";
import NotificationAlert from "react-notification-alert";

import "./style.css";

import mirandaIcon from "assets/img/miranda-mark.svg";
import mirandaText from "assets/img/miranda-logo.svg";

const Login = () => {
  const [form, setForm] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);

  const navigate = useNavigate();
  const ctx = useContext(ApiContext);
  const login = ctx && ctx.login;
  const notificationAlertRef = useRef(null);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (typeof login === "function") {
      login(form.email, form.password)
        .then((res) => {
          const msg = "Autenticado com sucesso!";
          notify("tr", "success", msg, "icon-check-2");

          const accountId = res?.user?.accountId;
          setTimeout(() => {
            navigate(accountPath(accountId, "/dashboard"));
          }, 800);
        })
        .catch((err) => {
          const apiMsg = err?.response?.data?.message;
          const msg =
            typeof apiMsg === "string"
              ? apiMsg
              : Array.isArray(apiMsg)
                ? apiMsg.join(", ")
                : "E-mail ou senha inválidos";
          notify("tr", "danger", msg, "icon-alert-circle-exc");
        });
    } else {
      const msg = "Erro interno: login não disponível";
      notify("tr", "danger", msg, "icon-alert-circle-exc");
    }
  };

  const notify = (place, type, msg, icon) => {
    const options = {
      place,
      message: <div>{msg}</div>,
      type,
      icon: `tim-icons ${icon}`,
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  return (
    <div className="login-page">
      <div className="login-bg-shapes">
        <div className="login-bg-shape login-bg-shape--dots" />
        <div className="login-bg-shape login-bg-shape--rect1" />
        <div className="login-bg-shape login-bg-shape--rect2" />
        <div className="login-bg-shape login-bg-shape--rect3" />
        <div className="login-bg-shape login-bg-shape--blue" />
      </div>

      <div className="react-notification-alert-container login-notification">
        <NotificationAlert ref={notificationAlertRef} />
      </div>

      <div className="login-container">
        <div className="login-brand">
          <div className="login-brand-logo">
            <img
              src={mirandaText}
              alt="Miranda Software"
              className="login-brand-logo-text"
            />
            <span className="login-product-badge">PedeGo</span>
          </div>

          <h1 className="login-brand-title">
            <span className="login-brand-highlight">PedeGo:</span> seu restaurante
            no controle.
          </h1>

          <p className="login-brand-subtitle">
            Receba pedidos, acompanhe a cozinha e gerencie seu estabelecimento
            em um só lugar.
          </p>

          <div className="login-features">
            <div className="login-feature">
              <i className="fas fa-bolt" />
              <span>Rápido</span>
            </div>
            <div className="login-feature">
              <i className="fas fa-shield-alt" />
              <span>Seguro</span>
            </div>
            <div className="login-feature">
              <i className="fas fa-chart-bar" />
              <span>Inteligente</span>
            </div>
          </div>
        </div>

        <div className="login-card">
          <div className="login-card-icon">
            <img src={mirandaIcon} alt="PedeGo por Miranda Software" />
          </div>

          <h2 className="login-card-title">Bem-vindo ao PedeGo! 👋</h2>
          <p className="login-card-subtitle">
            Entre para gerenciar seus pedidos
          </p>

          <form className="login-form" onSubmit={handleSubmit}>
            <div className="login-field">
              <label htmlFor="email">E-mail</label>
              <div className="login-input-wrapper">
                <i className="fas fa-user login-input-icon" />
                <input
                  id="email"
                  type="email"
                  placeholder="seu@email.com"
                  value={form.email}
                  onChange={(e) =>
                    setForm({ ...form, email: e.target.value })
                  }
                  required
                />
              </div>
            </div>

            <div className="login-field">
              <label htmlFor="password">Senha</label>
              <div className="login-input-wrapper">
                <i className="fas fa-lock login-input-icon" />
                <input
                  id="password"
                  type={showPassword ? "text" : "password"}
                  placeholder="••••••••"
                  value={form.password}
                  onChange={(e) =>
                    setForm({ ...form, password: e.target.value })
                  }
                  required
                />
                <button
                  type="button"
                  className="login-password-toggle"
                  onClick={() => setShowPassword(!showPassword)}
                  tabIndex={-1}
                >
                  <i
                    className={`fas fa-eye${showPassword ? "-slash" : ""}`}
                  />
                </button>
              </div>
            </div>

            <div className="login-options">
              <label className="login-remember">
                <input
                  type="checkbox"
                  checked={rememberMe}
                  onChange={(e) => setRememberMe(e.target.checked)}
                />
                <span>Lembrar de mim</span>
              </label>
              <a href="#esqueceu" className="login-forgot">
                Esqueceu sua senha?
              </a>
            </div>

            <button type="submit" className="login-submit">
              <i className="fas fa-sign-in-alt" />
              Entrar
            </button>
          </form>

          <p className="login-legal">
            <a href="https://pedego.online/privacidade" target="_blank" rel="noopener noreferrer">
              Privacidade
            </a>
            <span aria-hidden="true"> · </span>
            <a href="https://pedego.online/termos" target="_blank" rel="noopener noreferrer">
              Termos de uso
            </a>
          </p>

          {/* <div className="login-divider">
            <span>ou</span>
          </div>

          <button type="button" className="login-google">
            <svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true">
              <path
                fill="#4285F4"
                d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
              />
              <path
                fill="#34A853"
                d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
              />
              <path
                fill="#FBBC05"
                d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
              />
              <path
                fill="#EA4335"
                d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
              />
            </svg>
            Entrar com Google
          </button> */}

          {/* <p className="login-footer">
            Ainda não tem uma conta?{" "}
            <a href="#criar">Crie agora</a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Login;
